import { IAction, StateStatus } from 'redux/utils/common';
import { ITopicOutput } from 'services/api/topic';
import * as Types from './types';
import * as ProductService from 'services/api/product';
import { IDescriptionData } from '../configuration';

interface ICategoryTopic {
  id: number;
  name: string;
  description: string;
  displayorder: number;
  storeid: number;
}

interface IPaging {
  page: number;
  pageSize: number;
  total: number;
}

export interface IState {
  topicData: {
    status: StateStatus | null;
    data: ITopicOutput | null;
  };
  updateTopic: {
    status: StateStatus | null;
  };

  segments: {
    data: ProductService.ISegments | null;
    status: StateStatus | null;
  };
  temporaryDescription: IDescriptionData[];
  temporaryTitle: IDescriptionData[];
  categoryTopic: {
    data: {
      items: ICategoryTopic[] | null;
      paging: IPaging | null;
    };
    status: StateStatus | null;
  };
}

const initialState: IState = {
  topicData: {
    status: null,
    data: null,
  },
  updateTopic: {
    status: null,
  },
  segments: {
    data: null,
    status: null,
  },
  temporaryDescription: [],
  temporaryTitle: [],
  categoryTopic: {
    data: {
      items: null,
      paging: null,
    },
    status: null,
  },
};

const TopicEditReducer = (
  state: IState = initialState,
  action: IAction
): IState => {
  switch (action.type) {
    case Types.SET_ONE_TOPIC:
      return {
        ...state,
        topicData: {
          ...state.topicData,
          status: action.status || null,
          data: action.data,
        },
      };
    case Types.SET_SEGMENTS:
      return {
        ...state,
        segments: {
          ...state.segments,
          status: action.status || null,
          data: action.data,
        },
      };
    case Types.SET_CATEGORY_TOPIC:
      return {
        ...state,
        categoryTopic: {
          ...state.categoryTopic,
          status: action.status || null,
          data: action.data,
        },
      };
    case Types.UPDATE_TOPIC:
      return {
        ...state,
        updateTopic: {
          status: action.status || null,
        },
      };
    case Types.UPDATE_DESCRIPTION_TOPIC_TEMPORARY:
      return {
        ...state,
        temporaryDescription: action.data,
      };
    case Types.UPDATE_TITLE_TOPIC_TEMPORARY:
      return {
        ...state,
        temporaryTitle: action.data,
      };
    default:
      return {
        ...state,
      };
  }
};

export default TopicEditReducer;
